module.exports = __webpack_public_path__ + "media/icons/card-f776891f.svg";